import * as yup from 'yup';

export const FibuConfigurationSchema = yup.object({
  companyNumber: yup.number().required().moreThan(0),
  debtorAccount: yup.number().required().moreThan(0),
  careFundAccount: yup.number().required().moreThan(0),
  socialWelfareOfficeAccount: yup.number().required().moreThan(0),
  bankAccount: yup.number().required().moreThan(0),
});

export interface IFibuConfiguration {
  companyNumber: number;
  debtorAccount: number;
  careFundAccount: number;
  socialWelfareOfficeAccount: number;
  bankAccount: number;
  costObjectNumberCount?: number;
}
